export class ResourcePermissionConstants {
  public static readonly CREATE_RESOURCE = "createResource";
}
